import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";

import { useConfirmSignUp } from "@/hooks/use-auth-client/use-confirm-sign-up";

import { QUERY_PARAMS } from "@/routes/_constants/query-params";
import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info/_hooks/use-toast";

export const useGetSignUpVerifyParams = () => {
	const [searchParams] = useSearchParams();

	const navigate = useNavigate();

	const { confirmSignUp } = useConfirmSignUp();

	const verifyCode = searchParams.get(QUERY_PARAMS.AUTH.SIGN_UP_VERIFY.VERIFY_CODE);
	const email = searchParams.get(QUERY_PARAMS.AUTH.SIGN_UP_VERIFY.USERNAME);

	useEffect(() => {
		const callback = async () => {
			if (!verifyCode && !email) {
				notifyUserEventInfo({
					title: "",
					description: "URLが正しくありません。メールを再度ご確認ください。",
				});

				navigate(PATHS.AUTH.SIGN_UP);
			} else {
				await confirmSignUp(email!, verifyCode!);
			}
		};

		callback();
	}, [email, verifyCode, confirmSignUp, navigate]);
};
